module.exports = __webpack_public_path__ + "invite-owner-form.html";


//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice/invite-owner-form.html
// module id = 743
// module chunks = 0